
/**
 * Wedging distance mappings
 */

export const getWedgingDistances = (testId: string): Record<string, string> => {
  // Pour le test de niveau 1
  if (testId === "wedging-cercles") {
    return {
      "G": "60m", 
      "H": "80m", 
      "I": "100m",
      // Pour compatibilité avec le système de scoring
      "WedgingA": "30m",
      "WedgingB": "40m",
      "WedgingC": "50m"
    };
  } else if (testId === "wedging-pente-gauche") {
    return {
      "G1": "60m",
      "H1": "80m",
      "I1": "100m",
      // Pour compatibilité avec le système de scoring
      "WedgingA1": "30m",
      "WedgingB1": "40m",
      "WedgingC1": "50m"
    };
  } else if (testId === "wedging-pente-droite") {
    return {
      "G2": "60m",
      "H2": "80m",
      "I2": "100m",
      // Pour compatibilité avec le système de scoring
      "WedgingA2": "30m",
      "WedgingB2": "40m",
      "WedgingC2": "50m"
    };
  } else if (testId === "wedging-mid-pente-gauche") {
    return {
      "G1": "60m",
      "H1": "70m",
      "I1": "90m",
      // Pour compatibilité avec le système de scoring
      "WedgingD1": "60m",
      "WedgingE1": "70m",
      "WedgingF1": "90m"
    };
  } else if (testId === "wedging-mid-pente-droite") {
    return {
      "G2": "60m",
      "H2": "70m",
      "I2": "90m",
      // Pour compatibilité avec le système de scoring
      "WedgingD2": "60m",
      "WedgingE2": "70m",
      "WedgingF2": "90m"
    };
  } else if (testId === "wedging-mid") {
    return {
      "G2": "75m",
      "H2": "85m",
      "I2": "95m",
      // Pour compatibilité avec le système de scoring
      "WedgingA2": "75m",
      "WedgingB2": "85m",
      "WedgingC2": "95m",
      // Pour Level 3
      "WedgingD": "60m",
      "WedgingE": "70m",
      "WedgingF": "90m"
    };
  }

  // Pour les tests de niveau 3
  return {
    "WedgingA": "30m",
    "WedgingB": "40m",
    "WedgingC": "50m",
    "WedgingD": "60m",
    "WedgingE": "70m",
    "WedgingF": "90m",
    "WedgingA2": "30m",
    "WedgingB2": "40m",
    "WedgingC2": "50m"
  };
};
